/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-loader[_ngcontent-%COMP%] {\r\n    height: 100%;\r\n    width:100%;\r\n    padding-right: 5px;\r\n    display: block;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n        -ms-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    background: rgba(255,255, 255, 0.5) ;\r\n    \r\n    min-height: 150px;\r\n}"];
export { styles as styles };
